import { render, staticRenderFns } from "./FillRejectText.vue?vue&type=template&id=00fcbc35&scoped=true&"
import script from "./FillRejectText.vue?vue&type=script&lang=js&"
export * from "./FillRejectText.vue?vue&type=script&lang=js&"
import style0 from "./FillRejectText.vue?vue&type=style&index=0&id=00fcbc35&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcbc35",
  null
  
)

export default component.exports